import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: string;
  message: string;
  action?: ReactNode;
  padding?: number;
}

export function EmptyState({ icon, message, action, padding = 48 }: EmptyStateProps) {
  return (
    <div className="funcat-empty" style={{ padding: `${padding}px 0` }}>
      <i className={`fas ${icon}`} aria-hidden="true" />
      <p>{message}</p>
      {action}
    </div>
  );
}
